import { render } from "./PhysiciansFilters.vue?vue&type=template&id=e8ef6cb0"
import script from "./PhysiciansFilters.vue?vue&type=script&lang=js"
export * from "./PhysiciansFilters.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\Website\\wwwroot\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__